import { Build, Component, Element, h, Prop, State } from '@stencil/core';

@Component({
  tag: 'mama-openstreet-map',
  styleUrl: './mama-openstreet-map.scss',
})
export class MamaOpenstreetMap {
  @Element() el!: HTMLElement;

  @Prop() tileLayer: string = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  @Prop() latitude: number;
  @Prop() longitude: number;
  @Prop() zoom: number;

  private map;

  @State() hideOverlay = false;

  observer?: IntersectionObserver;

  componentWillLoad() {
    if (localStorage.getItem('mama-osm-hide-overlay') !== null) {
      this.hideOverlay = true;
    }
  }

  async componentDidLoad() {
    if (!Build.isBrowser) {
      return;
    }

    this.observer = new IntersectionObserver((entries, observer) => this.initializeMap(entries[0], observer), { rootMargin: '200px' });
    this.observer.observe(this.el);
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = undefined;
    }
  }

  async initializeMap(entry: IntersectionObserverEntry, observer: IntersectionObserver) {
    if (!entry.isIntersecting) {
      return;
    }
    observer.unobserve(entry.target);

    const L = await import('leaflet');
    // Bugfix for leaflet is setting wrong images urls for markers
    delete L.Icon.Default.prototype._getIconUrl;
    const placeholder = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: placeholder,
      iconUrl: placeholder,
      shadowUrl: placeholder,
    });

    this.map = L.map('mama-openstreet-map');
    this.map.setView([this.latitude, this.longitude], this.zoom);
    L.tileLayer(this.tileLayer, {
      attribution: '<a href="https://www.openstreetmap.org/copyright">&copy; OpenStreetMap-Mitwirkende</a>',
    }).addTo(this.map);
    L.marker([this.latitude, this.longitude]).addTo(this.map);
  }

  closeOverlay(event) {
    // Data privacy link should be clickable
    if (event.target.classList.contains('overlay')) {
      this.hideOverlay = true;
      localStorage.setItem('mama-osm-hide-overlay', '' + this.hideOverlay);
    }
  }

  render() {
    const overlayProperties = {
      class: {
        overlay: true,
        hidden: this.hideOverlay,
      },
    };

    return [
      <div {...overlayProperties} onClick={event => this.closeOverlay(event)} onFocus={event => this.closeOverlay(event)} tabindex="0">
        <slot name="overlay" />
      </div>,
      <div id="mama-openstreet-map" class="openstreet-map" />,
    ];
  }
}
